import http from '../_http'

const report = {
  //default
  summaryReport: (m) => { return http.get(`manager/wsfinder/report`, m); },
  listReport: (m) => { return http.post(`manager/wsfinder/report/list`, m); },
  detailReport: (m) => { return http.get(`manager/wsfinder/report/${m.id}`); },

  //crud
  insertReport: (m) => { return http.post(`manager/wsfinder/report`, m); },
  deleteReport: (m) => { return http.delete(`manager/wsfinder/report/${m.id}`); },
}

export default report

export { report }